import { prepareCategoriesAndBrandsForAppId,
  prepareCategoriesAndBrandsAndOutfitsForAppId } from '../Config/config.saga';
import {
  appConfigsSchema,
  clusterSchema,
  normalizeStory,
} from '../StoryList/storylist.saga';
import { TeaserData } from '../../modules/StoryEdit/components/Stream/Editors/TeaserEditor';
import { TeaserVideoData } from '../../modules/StoryEdit/components/Stream/Editors/TeaserVideoEditor';
import { showSnackbarWithMessage } from '../Snackbar/snackbar.saga';
import { StreamElement } from '../../modules/StoryEdit';
import {
  getActiveStoryEditTargetCategories,
  getActiveStoryId,
  getActiveStorySourceCategories,
  getStoryEditActiveAppId,
  getStoryEditStory,
  getEditCountry,
  getResourceIdsForStoryRows,
  getStoryActiveAppConfigByAppId,
  getStoryEditActiveAppConfig,
  getLanguageGroupMasterCountryForAppId,
  getTargetCategoriesByAppId,
  getProductIdsByAppId,
} from './story-edit.reducer';
import { getProductIdsByAppId as getEntityProductIdsByAppId } from '../Entities/Products/products.reducer';
import { take, call, put, select, fork, takeLatest } from 'redux-saga/effects';
import {
  addSourceCategoryForAppId,
  addStoryEditTargetCategory,
  deleteSourceCategory,
  editStoryFetched,
  removeStoryEditTargetCategory,
  resetStoryEdit,
  saveElementRow,
  saveTeaser,
  saveTeaserVideo,
  setActualStory,
  setStoryEditDates,
  startLoading,
  stopLoading,
  updateElementRow,
  updateStoryEditActiveDates,
  updateStoryEditBoostDates,
  updateStoryEditSourceCategories,
  updateStoryEditTargetCategories,
  updateStreamCategories,
  updateTeaser,
  updateTeaserVideo,
  copyStreamCategories,
  DeleteProductForAppIdPayload,
  DeleteOutfitForAppIdPayload,
  deleteOutfitForAppId as deleteOutfitForAppIdAction,
  removeOutfitIdForAppConfig,
  NewProductForAppIdPayload,
  NewOutfitForAppIdPayload,
  newOutfitForAppId,
  addOutfits,
  updateStoryEditRebrushedAt,
  SetStoryEditDatesPayload,
  rehydrateStreamCategory,
  updateHeadlinesByLanguagegroupForAppId,
  copyTargetCategories,
  copyBoostedProducts,
  updateProductIdsForAppId,
} from './story-edit.actions';
import { getStoryCallOptions } from '../../services/story.services';
import { callApi } from '../api';
import {
  getStreamCategoryConfig,
  mapToAttributeFilterList,
  getAvailableFilters,
  ConfigurationMode,
  getIsInheritedByChildCategories,
} from '../StreamCategoryConfig/stream-category-config.reducer';
import {
  SourceCategory,
  TargetCategory,
} from '../Entities/Stories/stories.reducer';
import { normalize, schema } from 'normalizr';
import { storySaveCallOptions } from '../../services/storyedit.services';
import {
  resetStreamConfig,
  selectStreamConfigCategory,
  addStreamConfigActiveFilterItems,
  setUpdateFilterItemsComplete,
  setStreamConfigMode,
} from '../StreamCategoryConfig/stream-category-config.actions';
import {
  saveStory as saveStoryAction,
  updateStoryEditActiveAppId,
  changeCountry as countryChangeAction,
  addProducts,
  copyDates,
  newProductForAppId,
  deleteProductForAppId as deleteProductForAppIdAction,
  removeProductIdForAppConfig,
  updateStreamProductCount,
} from './story-edit.actions';
import { getUrlParamFromState } from '../../utils/url';
import {
  countryByShortcode,
  Country,
  fillEmptyHeaderTextsWithGerman,
  countries,
  fillEmptyElementTextsForLanguageGroupOfCountry,
} from '../../utils/country';
import { replaceSite } from '../Navigation/navigation.actions';
import { fetchProductsForAppId } from '../Entities/Products/products.saga';
import { searchProductsCallOptions } from '../../services/products.services';
import { getAttributeGroupName } from '../../utils/attributes';
import { Action } from 'typescript-fsa';
import { append, reject } from 'ramda';
import * as R from 'ramda';
import { fetchOutfitsForAppId, fetchOutfitsForMultipleAppIds } from '../Entities/Outfits/outfits.saga';
import {
  getCategoryIdsByAppId,
  getSubCategoryIds,
} from '../Entities/Categories/categories.reducer';

const MAX_STORIES_COUNT = 50;

export const storyEditSchema = new schema.Entity(
  'story',
  {
    clusters: [clusterSchema],
    appConfigs: [appConfigsSchema],
  },
  {
    processStrategy: normalizeStory,
    idAttribute: 'id',
  }
);

export function* storyEditStart(storyId: number, country: Country) {
  yield put(resetStoryEdit());
  yield put(startLoading());
  const { id: appId } = country;
  const getCallOptions = getStoryCallOptions(storyId);
  const storyResponse = yield call(callApi, getCallOptions);

  if (!storyResponse.ok) {
    yield showSnackbarWithMessage('error', 'Could not fetch story');
    return;
  }

  const {
    entities: { appConfigs, story, cluster },
  } = normalize(storyResponse.data, storyEditSchema);

  yield put(editStoryFetched({ story: story[storyId], appConfigs, cluster }));

  yield put(updateStoryEditActiveAppId({ appId }));

  yield fork(prepareCategoriesAndBrandsForAppId, appId);

  yield call(fetchProductsFromRows);
  yield call(fetchOutfitsFromRows);

  yield call(fetchProductsForAppConfig);
  yield call(fetchOutfitsForAppConfig);

  yield call(fetchProductCountFromStream);

  yield put(stopLoading());
}

export function* fetchProductCountForSourceCategory(
  sourceCategory: SourceCategory,
  appId: number
) {
  let filters = {};
  if (sourceCategory.attributeFilters) {
    for (let filter of sourceCategory.attributeFilters) {
      filters[getAttributeGroupName(filter.attributeGroupId)] =
        filter.attributeIds;
    }
  }

  const callOptions = yield searchProductsCallOptions(
    sourceCategory.categoryId,
    appId,
    0,
    0,
    filters
  );
  const { ok, data } = yield call(callApi, callOptions);

  if (!ok) {
    return 0;
  }

  return data && data.totalCount;
}

export function* fetchProductCountFromStream() {
  const state = yield select();
  const streamSourceCategories = getActiveStorySourceCategories(state);
  const appId = getStoryEditActiveAppId(state);
  let count = 0;

  if (streamSourceCategories && streamSourceCategories.length > 0) {
    for (let i in streamSourceCategories) {
      const sourceCat: SourceCategory = streamSourceCategories[i];
      if (!sourceCat.id) {
        break;
      }

      let filters = {};
      if (sourceCat.attributeFilters) {
        for (let filter of sourceCat.attributeFilters) {
          filters[getAttributeGroupName(filter.attributeGroupId)] =
            filter.attributeIds;
        }
      }

      const callOptions = yield searchProductsCallOptions(
        sourceCat.categoryId,
        appId,
        0,
        0,
        filters
      );
      const { ok, data } = yield call(callApi, callOptions);

      if (ok) {
        count += data.totalCount;
      }
    }
  }
  yield put(updateStreamProductCount({ appId, count }));
}

export function* fetchProductsForAppConfig() {
  const state = yield select();
  const activeAppConfig = getStoryEditActiveAppConfig(state);

  if (activeAppConfig) {
    const { product_ids, app_id } = activeAppConfig;
    if (product_ids && product_ids.length > 0) {
      yield call(fetchProductsForAppId, app_id, product_ids);
    }
  }
}

export function* fetchOutfitsForAppConfig(fromActiveAppConfig: boolean = true) {
  const state = yield select();

  if (fromActiveAppConfig) {
    const activeAppConfig = getStoryEditActiveAppConfig(state);

    if (activeAppConfig) {
      const { outfit_ids, app_id } = activeAppConfig;
      if (outfit_ids && outfit_ids.length > 0) {
        yield call(fetchOutfitsForAppId, app_id, outfit_ids);
      }
    }
  } else {
    const APP_ID_DE = 139;
    const { storyEdit: { appConfigs }, story: { appConfig: appIds } } = state;
    const appConfigDe = appConfigs[APP_ID_DE];

    if (appConfigDe) {
      const { outfit_ids } = appConfigDe;
      if (outfit_ids && outfit_ids.length > 0) {
        yield call(fetchOutfitsForMultipleAppIds, appIds, outfit_ids);
      }
    }
  }
}

export function* doCopyDates(fromAppId: number, toAppId: number) {
  const state = yield select();
  const appConfig = getStoryActiveAppConfigByAppId(state, fromAppId);
  if (appConfig) {
    const {
      boost_from,
      boost_to,
      active_from,
      active_to,
      rebrushed_at,
    } = appConfig;
    yield put(
      updateStoryEditBoostDates({
        appId: toAppId,
        boost_from: boost_from || null,
        boost_to: boost_to || null,
      })
    );

    yield put(
      updateStoryEditActiveDates({
        appId: toAppId,
        active_from: active_from || null,
        active_to: active_to || null,
      })
    );

    yield put(
      updateStoryEditRebrushedAt({
        appId: toAppId,
        rebrushed_at: rebrushed_at || null,
      })
    );
  }
}

export function* watchForCopyDates() {
  while (true) {
    const {
      payload: { sourceAppId, targetAppId },
    } = yield take(copyDates.type);
    yield call(doCopyDates, sourceAppId, targetAppId);
  }
}

export function* watchForCopyTargetCategories() {
  while (true) {
    const {
      payload: { sourceAppId, targetAppId },
    }: { payload: { sourceAppId: number; targetAppId: number } } = yield take(
      copyTargetCategories.type
    );

    if (!sourceAppId || !targetAppId) {
      return;
    }

    const state = yield select();
    const categoryIdsOfTargetAppId = getCategoryIdsByAppId(state, targetAppId);
    const nextTargetCategories = (R.unionWith(
      R.eqBy(R.prop('category_id')),
      getTargetCategoriesByAppId(state, sourceAppId),
      getTargetCategoriesByAppId(state, targetAppId)
    ) as TargetCategory[]).filter(({ category_id: categoryId }) =>
      categoryIdsOfTargetAppId.includes(categoryId.toString())
    );

    yield put(
      updateStoryEditTargetCategories({
        appId: targetAppId,
        targetCategories: nextTargetCategories,
      })
    );
    yield call(saveStory);
  }
}

export function* watchForCopyBoostedProducts() {
  while (true) {
    const {
      payload: { sourceAppId, targetAppId },
    }: { payload: { sourceAppId: number; targetAppId: number } } = yield take(
      copyBoostedProducts.type
    );

    if (!sourceAppId || !targetAppId) {
      return;
    }

    const state = yield select();
    const suggestedBoostedProductIds = R.union(
      getProductIdsByAppId(state, targetAppId),
      getProductIdsByAppId(state, sourceAppId)
    );

    yield call(fetchProductsForAppId, targetAppId, suggestedBoostedProductIds);

    const availableProductIdsForTargetAppId = getEntityProductIdsByAppId(
      yield select(),
      targetAppId
    );
    const nextBoostedProductIds = suggestedBoostedProductIds.filter(id =>
      availableProductIdsForTargetAppId.includes(id.toString())
    );

    yield put(
      updateProductIdsForAppId({
        appId: targetAppId,
        productIds: nextBoostedProductIds,
      })
    );
    yield call(saveStory);
  }
}

export function* watchForStoryEditStart() {
  while (true) {
    const {
      payload: { storyId },
    } = yield take(setActualStory.type);
    const state = yield select();
    const shortcode = getUrlParamFromState('country', state, 'de');
    const country = countryByShortcode(shortcode || 'de');

    yield call(storyEditStart, storyId, country);
  }
}

function* updateActive(appId: number, activeFrom?: string, activeTo?: string) {
  const newDates = {
    appId,
    active_from: activeFrom || null,
    active_to: (activeFrom && activeTo) || null,
  };

  yield put(updateStoryEditActiveDates(newDates));
}

function* updateBoost(appId: number, boostFrom?: string, boostTo?: string) {
  const newDates = {
    appId,
    boost_from: boostFrom || null,
    boost_to: boostTo || null,
  };

  yield put(updateStoryEditBoostDates(newDates));
}

function* updateRebrushedAt(appId: number, rebrushedAt?: string) {
  yield put(
    updateStoryEditRebrushedAt({
      appId,
      rebrushed_at: rebrushedAt || null,
    })
  );
}

export function* watchForSetStoryEditDates() {
  const worker = function*(action: Action<SetStoryEditDatesPayload>) {
    const { payload } = action;
    const state = yield select();
    const appId = getStoryEditActiveAppId(state);
    const {
      active_from,
      active_to,
      boost_from,
      boost_to,
      rebrushed_at,
    } = payload;

    yield updateActive(appId, active_from, active_to);
    yield updateBoost(appId, boost_from, boost_to);
    yield updateRebrushedAt(appId, rebrushed_at);
    yield fork(saveStory);
  };

  yield takeLatest(setStoryEditDates, worker);
}

export function* updateSourceCategories() {
  const state = yield select();
  const { appId, categoryId } = getStreamCategoryConfig(state);
  const {
    storyEdit: { appConfigs },
  } = state;

  if (!appId || !categoryId) {
    yield showSnackbarWithMessage('error', 'Unable to save streamCategory');
    return;
  }

  const isInheritedByChildCategories = getIsInheritedByChildCategories(state);
  const categoryIds = isInheritedByChildCategories
    ? yield select(getSubCategoryIds, appId, categoryId)
    : [categoryId];
  const newCategories = categoryIds.map((id: number) => ({
    appConfigId: appConfigs[appId].id,
    categoryId: id,
    attributeFilters: mapToAttributeFilterList(state),
  }));

  if (
    appConfigs[appId].sourceCategories.length + newCategories.length >
    MAX_STORIES_COUNT
  ) {
    return yield showSnackbarWithMessage(
      'error',
      'Selected categories amount cannot exceed 50 in total. Please perform more granular selection.'
    );
  }

  yield put(addSourceCategoryForAppId({ appId, categories: newCategories }));

  yield saveStory();

  yield call(fetchProductCountFromStream);

  yield put(resetStreamConfig());
}

export function* watchForCopyStream() {
  while (true) {
    const {
      payload: { categories, appId },
    } = yield take(copyStreamCategories.type);

    yield put(addSourceCategoryForAppId({ appId, categories }));

    yield saveStory();

    yield call(fetchProductCountFromStream);

    yield put(resetStreamConfig());
  }
}

export function* watchForStreamCategoryUpdate() {
  while (true) {
    yield take(updateStreamCategories.type);
    yield updateSourceCategories();
  }
}

export function* watchForRehydrateStreamCategory() {
  while (true) {
    const {
      payload: {
        sourceCategory: { category, attributeFilters },
      },
    } = yield take(rehydrateStreamCategory.type);
    const state = yield select();
    const appId = getStoryEditActiveAppId(state);

    yield put(resetStreamConfig());
    yield put(setStreamConfigMode({ mode: ConfigurationMode.Edit }));

    yield put(
      selectStreamConfigCategory({
        categoryId: category.id,
        appId,
      })
    );

    yield take(setUpdateFilterItemsComplete);

    const filterNames = yield select(getAvailableFilters);

    const filterItems = attributeFilters.reduce(
      (acc, { attributeIds, attributeGroupId }) => [
        ...acc,
        ...attributeIds.map((id: number) => {
          const filterId = getAttributeGroupName(attributeGroupId);
          const filter = filterNames[filterId].find(f => f.id === id);
          const name = filter ? filter.name : filterId;

          return { id, attributeGroupId, name, filterId };
        }),
      ],
      []
    );

    yield put(addStreamConfigActiveFilterItems({ filterItems }));
  }
}

export function* saveStory() {
  yield put(startLoading());
  const state = yield select();

  const saveCallOptions = storySaveCallOptions(state);

  const storyResponse = yield call(callApi, saveCallOptions);
  if (storyResponse.ok) {
    const {
      entities: { appConfigs, story },
    } = normalize(storyResponse.data, storyEditSchema);

    yield put(
      editStoryFetched({
        story: story[getActiveStoryId(state)],
        appConfigs,
      })
    );

    yield put(stopLoading());
    yield fork(showSnackbarWithMessage, 'success', 'Story saved');
  } else {
    yield put(stopLoading());
    showSnackbarWithMessage('error', 'Story could not be saved');
  }
}

export function* watchForAddStoryEditTargetCategory() {
  while (true) {
    const {
      payload: { category },
    } = yield take(addStoryEditTargetCategory.type);
    const state = yield select();
    const targetCategories = getActiveStoryEditTargetCategories(state);
    const appId = getStoryEditActiveAppId(state);
    const tempTargetCategory: TargetCategory = {
      id: `temp_${category.id}`,
      category_id: category.id,
      isPinned: false,
      sourceCategory: category,
    };
    yield put(
      updateStoryEditTargetCategories({
        appId,
        targetCategories: append(
          tempTargetCategory,
          targetCategories || []
        ) as any,
      })
    );
    yield call(saveStory);
  }
}

export function* watchForRemoveStoryEditTargetCategory() {
  while (true) {
    const {
      payload: { targetCategory },
    } = yield take(removeStoryEditTargetCategory.type);
    const state = yield select();
    const targetCategories = getActiveStoryEditTargetCategories(state);
    const appId = getStoryEditActiveAppId(state);
    yield put(
      updateStoryEditTargetCategories({
        appId,
        targetCategories: reject(
          activeTargetCategory =>
            targetCategory.category_id === activeTargetCategory.category_id,
          targetCategories
        ),
      })
    );
    yield call(saveStory);
  }
}

export function* watchDeleteSourceCategory() {
  while (true) {
    const {
      payload: { sourceCategoryId },
    } = yield take(deleteSourceCategory.type);

    const state = yield select();
    const appId = getStoryEditActiveAppId(state);
    const sourceCategories = getActiveStorySourceCategories(state);
    yield put(
      updateStoryEditSourceCategories({
        appId,
        sourceCategories: reject(
          item => item.id === sourceCategoryId,
          sourceCategories
        ),
      })
    );
    yield call(saveStory);

    yield call(fetchProductCountFromStream);
  }
}

export function* watchForElementRowSave() {
  while (true) {
    const { payload } = yield take(saveElementRow.type);
    const state = yield select();
    const activeCountry = getEditCountry(state);
    const { shortcode } = activeCountry;
    yield put(
      updateElementRow(
        fillEmptyElementTextsForLanguageGroupOfCountry(payload, shortcode)
      )
    );

    yield call(saveStory);
  }
}

export function* watchForTeaserSave() {
  while (true) {
    const { payload } = yield take(saveTeaser.type);
    const state = yield select();
    const { shortcode } = getEditCountry(state);
    const editStory = getStoryEditStory(state);
    const data = (payload as StreamElement).data as TeaserData;

    const updatedStory = {
      ...editStory,
      headline: {
        ...(editStory.headline ? editStory.headline : {}),
        ...(data.headline ? data.headline : {}),
      },
      subline: {
        ...(editStory.subline ? editStory.subline : {}),
        ...(data.subline ? data.subline : {}),
      },
      headlineLong: {
        ...(editStory.headlineLong ? editStory.headlineLong : {}),
        ...(data.headlineLong ? data.headlineLong : {}),
      },
      sublineLong: {
        ...(editStory.sublineLong ? editStory.sublineLong : {}),
        ...(data.sublineLong ? data.sublineLong : {}),
      },
      headerImageBrandId: data.headerImageBrandId,
      appImage: data.appImage || editStory.appImage,
      mobileImage: data.mobileImage || editStory.mobileImage,
      desktopImage: { ...editStory.desktopImage, ...data.desktopImage },
      largerDesktopTeaser: data.largerDesktopTeaser,
    };

    yield put(
      updateTeaser(
        shortcode === 'de'
          ? fillEmptyHeaderTextsWithGerman(updatedStory)
          : updatedStory
      )
    );
    yield call(saveStory);
  }
}

export function* watchForTeaserVideoSave() {
  while (true) {
    const { payload } = yield take(saveTeaserVideo.type);
    const state = yield select();
    const { shortcode } = getEditCountry(state);
    const editStory = getStoryEditStory(state);
    const data = (payload as StreamElement).data as TeaserVideoData;
    const updatedStory = {
      ...editStory,
      headline: {
        ...(editStory.headline ? editStory.headline : {}),
        ...(data.headline ? data.headline : {}),
      },
      subline: {
        ...(editStory.subline ? editStory.subline : {}),
        ...(data.subline ? data.subline : {}),
      },
      mobileImage: { ...editStory.mobileImage, ...data.mobileImage },
      desktopImage: { ...editStory.desktopImage, ...data.desktopImage },
      ownerImage: { ...editStory.ownerImage, ...data.ownerImage },
    };

    yield put(
      updateTeaserVideo(
        shortcode === 'de'
          ? fillEmptyHeaderTextsWithGerman(updatedStory)
          : updatedStory
      )
    );
    yield call(saveStory);
  }
}

export function* changeCountry(country: Country) {
  const { shortcode, id: appId } = country;
  const {
    storyEdit: {
      story: { id: storyId },
    },
    entities: { brands, categories, outfits },
  } = yield select();

  yield put(startLoading());

  yield put(updateStoryEditActiveAppId({ appId }));

  if (!brands || !brands[appId] || !categories || !categories[appId] || !outfits || !outfits[appId]) {
    yield fork(prepareCategoriesAndBrandsAndOutfitsForAppId, appId);
  }

  yield call(fetchProductsForAppConfig);

  if (storyId) {
    yield put(replaceSite(`/stories/${storyId}/edit?country=${shortcode}`));
  }

  yield put(stopLoading());
}

export function* watchForUpdateHeadlinesByLanguagegroupForAppId() {
  while (true) {
    const {
      payload: { appId },
    } = yield take(updateHeadlinesByLanguagegroupForAppId.type);

    const editStory = yield select(getStoryEditStory);
    const country = countries.find(c => c.id === appId);
    const masterCountry = yield select(
      getLanguageGroupMasterCountryForAppId,
      appId
    );

    if (!country || !masterCountry) {
      continue;
    }

    yield put(
      updateTeaser({
        ...editStory,
        headline: {
          ...editStory.headline,
          [country.shortcode]: editStory.headline[masterCountry.shortcode],
        },
        subline: {
          ...editStory.subline,
          [country.shortcode]: editStory.subline[masterCountry.shortcode],
        },
        headlineLong: {
          ...editStory.headlineLong,
          [country.shortcode]: editStory.headlineLong[masterCountry.shortcode],
        },
        sublineLong: {
          ...editStory.sublineLong,
          [country.shortcode]: editStory.sublineLong[masterCountry.shortcode],
        },
      })
    );
  }
}

export function* watchForCountryChange() {
  while (true) {
    const {
      payload: { country },
    } = yield take(countryChangeAction.type);
    yield changeCountry(country);

    yield call(fetchProductCountFromStream);
  }
}

export function* watchSaveStory() {
  const worker = function*() {
    yield call(saveStory);
  };

  yield takeLatest(saveStoryAction, worker);
}

export function* fetchProductsFromRows() {
  yield put(startLoading());

  const state = yield select();
  const productIds = getResourceIdsForStoryRows(state, 'product');
  const appId = getStoryEditActiveAppId(state);

  if (productIds && productIds.length > 0) {
    yield call(fetchProductsForAppId, appId, productIds);

    yield put(addProducts({ appId, productIds }));
  }

  yield put(stopLoading());
}

export function* fetchOutfitsFromRows() {
  yield put(startLoading());

  const state = yield select();
  const outfitIds = getResourceIdsForStoryRows(state, 'outfit');

  const appId = getStoryEditActiveAppId(state);

  if (outfitIds && outfitIds.length > 0) {
    yield call(fetchOutfitsForAppId, appId, outfitIds);

    yield put(addOutfits({ appId, outfitIds }));
  }

  yield put(stopLoading());
}

export function* addOutfitForAppId(appId: number, outfitId: number) {
  yield fork(fetchOutfitsForAppId, appId, [outfitId]);
  yield put(addOutfits({ appId, outfitIds: [outfitId] }));
  yield fork(saveStory);
}

export function* addOutfitForAppIdWithoutSaving(
  appId: number,
  outfitId: number,
  appIds?: number[]
) {
  if (appIds && appIds.length) {
    yield fork(fetchOutfitsForMultipleAppIds, appIds, [outfitId]);

    let appIdx;
    for (appIdx in appIds) {
      yield put(addOutfits({ appId: appIdx, outfitIds: [outfitId] }));
    }
  } else {
    yield fork(fetchOutfitsForAppId, appId, [outfitId]);
    yield put(addOutfits({ appId, outfitIds: [outfitId] }));
  }
}

export function* addProductForAppId(appId: number, productId: number) {
  yield fork(fetchProductsForAppId, appId, [productId]);
  yield put(addProducts({ appId, productIds: [productId] }));
  yield fork(saveStory);
}

export function* addProductForAppIdWithoutSaving(
  appId: number,
  productId: number
) {
  yield fork(fetchProductsForAppId, appId, [productId]);
  yield put(addProducts({ appId, productIds: [productId] }));
}

export function* watchForProductsForApp() {
  const worker = function*(action: Action<NewProductForAppIdPayload>) {
    const { appId, productId, dontSave } = action.payload;
    if (dontSave) {
      yield call(addProductForAppIdWithoutSaving, appId, productId);
    } else {
      yield call(addProductForAppId, appId, productId);
    }
  };

  yield takeLatest(newProductForAppId, worker);
}

export function* watchForOutfitsForApp() {
  const worker = function*(action: Action<NewOutfitForAppIdPayload>) {
    const { appId, outfitId, dontSave, appIds } = action.payload;
    if (dontSave) {
      yield call(addOutfitForAppIdWithoutSaving, appId, outfitId, appIds);
    } else {
      yield call(addOutfitForAppId, appId, outfitId);
    }
  };

  yield takeLatest(newOutfitForAppId, worker);
}

export function* deleteProductForAppId(appId: number, productId: number) {
  yield put(removeProductIdForAppConfig({ appId, productId }));

  yield call(saveStory);
}

export function* deleteOutfitForAppId(appId: number, outfitId: number) {
  yield put(removeOutfitIdForAppConfig({ appId, outfitId }));

  yield call(saveStory);
}

export function* watchDeleteProductFromAppConfig() {
  const worker = function*(action: Action<DeleteProductForAppIdPayload>) {
    const { appId, productId } = action.payload;
    yield call(deleteProductForAppId, appId, productId);
  };

  yield takeLatest(deleteProductForAppIdAction, worker);
}

export function* watchDeleteOutfitFromAppConfig() {
  const worker = function*(action: Action<DeleteOutfitForAppIdPayload>) {
    const { appId, outfitId } = action.payload;
    yield call(deleteOutfitForAppId, appId, outfitId);
  };

  yield takeLatest(deleteOutfitForAppIdAction, worker);
}



// WEBPACK FOOTER //
// ./src/store/StoryEdit/story-edit.saga.ts